<template>
  <div>
    <slot name="default">
      <div class="gallery-container" :style="{ 'grid-template-columns': gridTemplateColumnsStyle }">
        <div v-for="(imgBtn,i) in imgBtnArr"
          :key="imgBtn.id + '_' + i"
          class="gallery-item-container">
          <a href="javascript:void(0)"   
            class="gallery-item"
            :class="{ 'gallery-item-disabled': in_IsDisabled, 'gallery-item-round': roundBorder }"
            :style="galleryItemStyle" 
            @click="() => onClickImage(imgBtn.id)"
          >
            <img :key="imgBtn.imgSrc" :src="imgBtn.imgSrc" :alt="imgBtn.imageName" class="gallery-img" :class="{ 'gallery-img-round': roundBorder }"/>
            <div class="gallery-item-corner bottom-right" v-if="!in_IsDisabled && !isShowEditPen">
              <span class="material-symbols-outlined" style="font-size: 14px !important;">edit</span>
              {{ $t('lbl_EMPBE_Uploader_Editable') }}
            </div>
            <div v-if="i === 0 && isShowCover" class="gallery-item-corner top-right" style="background: #2C6ECB;">
              {{ mediaType === 'image' ? $t('lbl_EMPBE_UploaderCover') : $t('lbl_EMPBE_Uploader_MainVideo') }}
            </div>
          </a>

          <span v-if="!in_IsDisabled && isShowEditPen" class="gallery-item-edit-pen" @click="() => onClickImage(imgBtn.id)">
            <img :src="editPenImage" />
          </span>
        </div>

        <div v-for="i in numOfGallery"
            :key="'temp_' + i"
            class="gallery-item-container">
          <a href="javascript:void(0)"
            @click="() => onClickImage(null)"
            class="gallery-item-add"
            :class="{
              'gallery-item-add-error': IsRequiredStyle,
              'gallery-item-add-avatar': isAvatar,
              'gallery-item-disabled': in_IsDisabled,
            }"
            :style="galleryItemStyle"
          >
            <span v-if="!isAvatar" class="material-symbols-outlined">add_2</span>
            <span v-else>
              <img :src="defaultAvatarImage" />
            </span>
            <span class="cover-placeholder" v-if="i === 1 && temp_mediaArray.length === 0 && isShowCover">
              {{ coverPlaceholder }}
              <span v-if="isAllRequired || isRequired && imgBtnArr.length === 0" style="color: #CD1515;">*</span>
            </span>

            <span v-if="!in_IsDisabled && isShowEditPen" class="gallery-item-edit-pen" @click="() => onClickImage(null)">
              <img :src="editPenImage" />
            </span>
          </a>
        </div>
      </div>
    </slot>
    <media-upload-modal
      ref="MediaUploadModal"
      :media-type="mediaType"
      :aspect-ratio-str="aspectRatioStr" 
      :max-quota="limit"
      :medias="temp_mediaArray"
      :max-size="maxSize"
      :max-duration="maxDuration"
      :is-required="isRequired"
      :requirement-message="requirementMessage"
      :is-show-cover="isShowCover"
      :round-border="roundBorder"
      :is-show-video-preview-background="isShowVideoPreviewBackground"
      :reject-records="effectiveRejectRecords"
      @updateAndClose="handleUpdate"
    />
  </div>
</template>
<script>
  import mediaUploadModal from './mediaUploadModal.vue';
  import {
    getMediaUploaderImageDataObj,
    getMediaUploaderVideoDataObj,
    toPendingUploadQueueData
  } from '@/_helpers/media-uploader-utils.js';
  import { SHOW_EDIT_SUPPLIER_REJECT_REASON } from '@/constants/approvalRejectUi.js';

  export default {
    name: 'MediaUploader',
    components: {
      mediaUploadModal
    },
    props: {
      MediaArray: {type: Array, default: () => []},
      limit: {type: Number, default: 1},
      aspectRatioStr: {type: String, default: '1:1'},
      galleryItemStyle: {type: String, default: 'height: 120px; width: 120px;'},
      isRequired: {type: Boolean, default: false},
      isAllRequired: {type: Boolean, default: false},
      coverPlaceholder: {type: String, default: ''},
      mediaType: {
        type: String,
        default: 'image',
        validator: (value) => ['image', 'video'].includes(value),
      },
      maxSize: {type: Number, default: 500}, // maxSize in MB
      maxDuration: {type: Number, default: null}, // maxDuration in seconds
      requirementMessage: {type: String, default: ''},
      gridTemplateColumns: {type: String, default: ''},
      singleAddButton: {type: Boolean, default: false},
      isDisabled: {type: Boolean, default: false},
      isShowCover: {type: Boolean, default: false},
      roundBorder: {type: Boolean, default: false},
      isShowVideoPreviewBackground: {type: Boolean, default: false},
      fileUsageType: {type: String, required: true, default: ''},
      filePathEndpoint: {type: String, required: true, default: ''},
      fileThumbnailUsageType: {type: String, default: ''},
      fileThumbnailPathEndpoint: {type: String, default: ''},
      isAvatar: {type: Boolean, default: false},
      isShowEditPen: {type: Boolean, default: false},
      rejectRecords: { type: Array, default: () => [] },
    },
    // model: {
    //   prop: 'MediaArray',
    //   event: 'update'
    // },
    data() {
      return {
        // editedOrDeletedMediaIds: [],
        // addIcon: 'https://cdn.adsalecdn.com/EMP/Backend/svg/componentsIcon/Add.svg',
        IsRequiredStyle: false,
        in_IsDisabled: this.isDisabled,
        temp_mediaArray: [],
        imgBtnArr: [],
      }
    },
    watch: {
      isDisabled(val) {
        this.in_IsDisabled = val;
      },
      MediaArray: {
        handler(val) {
          // if (val && val.length > 0) {
            this.IsRequiredStyle = false;
            this.temp_mediaArray = val?.map(v => {
              return this.mediaType === 'image'
                ? getMediaUploaderImageDataObj(v)
                : this.mediaType === 'video'
                ? getMediaUploaderVideoDataObj(v)
                : v;
            }) || [];
          // }
        },
        deep: true,
        immediate: true,
      },
      temp_mediaArray: {
        // [BLK] Handler should be called only when temp_mediaArray is updated (only after getting data from API)
        // immediate: 与 MediaArray.immediate 配套；挂载时已有图时也要生成 imgBtnArr，否则只显示 +
        handler(val) {
          // [BLK] Update Image Btn display data
          if (this.mediaType === 'video') {
            this.imgBtnArr = (val || []).map((i) => ({
              id: i.id,
              imgSrc: i.thumbnail.previewSrc,
              imageName: i.fileName,
              usageType: i.usageType,
              isPendingUpload: false,
              isThumbnailPendingUpload: false
            }));
          } else if (this.mediaType === 'image') {
            this.imgBtnArr = (val || []).map((i) => ({
              id: i.id,
              imgSrc: i.previewSrc,
              imageName: i.fileName,
              usageType: i.usageType,
              isPendingUpload: false
            }));
          }
        },
        deep: true,
        immediate: true,
      },
    },
    computed: {
      gridTemplateColumnsStyle() {
        return this.gridTemplateColumns || `repeat(${this.limit}, 1fr)`;
      },
      defaultAvatarImage() {
        return process.env.VUE_APP_OSS_ORIGIN + "EMP/Backend/Images/AddPhoto.svg";
      },
      editPenImage() {
        return process.env.VUE_APP_OSS_ORIGIN + "EMP/Backend/svg/UserSetting/Pens.svg";
      },
      numOfGallery() {
        if (this.singleAddButton) {
          return this.limit > this.imgBtnArr.length ? 1 : 0;
        } else {
          return this.limit - this.imgBtnArr.length > 0 ? this.limit - this.imgBtnArr.length : 0;
        }
      },
      cdnLinks() {
        return this.temp_mediaArray.reduce((acc, cur) => {
          const cdnLinks = [];
          const fileCdnLink = cur.cdnLink;
          if (fileCdnLink) cdnLinks.push(fileCdnLink);
          const fileThumbnailCdnLink = (cur.thumbnail && cur.thumbnail.cdnLink) || '';
          if (fileThumbnailCdnLink) cdnLinks.push(fileThumbnailCdnLink);
          return [...acc, ...cdnLinks];
        }, []);
      },
      /** TEMP：编辑/供应商暂不向弹层传驳回原因 */
      effectiveRejectRecords() {
        return SHOW_EDIT_SUPPLIER_REJECT_REASON ? (this.rejectRecords || []) : [];
      },
    },
    methods: {
      isOneOfTheCdnLink(cdnLink) {
        return this.cdnLinks.includes(cdnLink);
      },
      emitData(medias, imgBtnArr) {
        // console.log('handleUpdate', medias);
        // console.log("temp_mediaArray: ", this.temp_mediaArray);

        const toBeUpdatedLength = medias.length;
        const commands = [];
        const pendingUploadFiles = [];
        const maxAmountOfLoop = Math.max(this.temp_mediaArray.length, toBeUpdatedLength);
        const defaultCommand = {
          command: "",
          originalId: 0,
          originalUrl: "",
          originalOrderId: 0,
          newId: 0,
          newUrl: "",
          usageType: this.fileUsageType,
          newOrderId: 0,
        };

        // [BLK] Generate commands and pendingUploadFiles
        for (let i = 0; i < maxAmountOfLoop; i++) {
          // [BLK] Delete in DB
          if (i >= toBeUpdatedLength && i < this.temp_mediaArray.length) {
            const originalMedia = this.temp_mediaArray[i];
            const originalOrderId = originalMedia.orderId;
            commands.push({
              ...defaultCommand,
              command: 'DELETE',
              originalId: originalMedia.id,
              originalUrl: originalMedia.cdnLink,
              originalOrderId,
            });

            const thumbnail = originalMedia.thumbnail;
            // [BLK] Delete thumbnail if has thumbnail
            if (thumbnail) {
              commands.push({
                ...defaultCommand,
                command: 'DELETE',
                originalId: thumbnail.id,
                originalUrl: thumbnail.cdnLink,
                usageType: this.fileThumbnailUsageType,
                originalOrderId,
              });
            }
          }
          // [BLK] Insert or Update in DB
          else if (i < toBeUpdatedLength) {
            const newMedia = medias[i];

            // [BLK] Upload to CDN
            if (newMedia.file) {
              pendingUploadFiles.push(toPendingUploadQueueData({
                ...newMedia,
                usageType: this.fileUsageType,
                pathEndpoint: this.filePathEndpoint,
              }));
            }

            // [BLK] Upload thumbnail to CDN if file has new thumbnail
            const thumbnail = newMedia.thumbnail;
            if (thumbnail && thumbnail.file) {
              pendingUploadFiles.push(toPendingUploadQueueData({
                ...thumbnail,
                usageType: this.fileThumbnailUsageType,
                pathEndpoint: this.fileThumbnailPathEndpoint,
              }));
            }

            // [BLK] Insert in DB
            if (i >= this.temp_mediaArray.length) {
              const newOrderId = newMedia.orderId;
              commands.push({
                ...defaultCommand,
                command: 'INSERT',
                newId: newMedia.id,
                newUrl: this.isOneOfTheCdnLink(newMedia.previewSrc) ? newMedia.previewSrc : "",
                newOrderId,
              });

              // [BLK] Insert thumbnail in DB if file has new thumbnail
              const thumbnail = newMedia.thumbnail;
              if (thumbnail) {
                commands.push({
                  ...defaultCommand,
                  command: 'INSERT',
                  newId: thumbnail.id,
                  newUrl: this.isOneOfTheCdnLink(thumbnail.previewSrc) ? thumbnail.previewSrc : "",
                  usageType: this.fileThumbnailUsageType,
                  newOrderId,
                });
              }
            }
            // [BLK] Update in DB
            else if (i < this.temp_mediaArray.length) {
              const originalMedia = this.temp_mediaArray[i];
              const newThumbnail = newMedia.thumbnail;
              if (originalMedia.cdnLink === newMedia.previewSrc && !newThumbnail) continue; // No need to update
              
              const newOrderId = newMedia.orderId;
              if (originalMedia.cdnLink !== newMedia.previewSrc) {
                commands.push({
                  ...defaultCommand,
                  command: 'UPDATE',
                  originalId: originalMedia.id,
                  originalUrl: originalMedia.cdnLink,
                  originalOrderId: originalMedia.orderId,
                  newId: newMedia.id,
                  newUrl: this.isOneOfTheCdnLink(newMedia.previewSrc) ? newMedia.previewSrc : "",
                  newOrderId,
                });
              }

              // [BLK] Update thumbnail
              if (newThumbnail && newThumbnail.previewSrc && !originalMedia.thumbnail) {
                commands.push({
                  ...defaultCommand,
                  command: 'INSERT',
                  newId: newThumbnail.id,
                  newUrl: this.isOneOfTheCdnLink(newThumbnail.previewSrc) ? newThumbnail.previewSrc : "",
                  usageType: this.fileThumbnailUsageType,
                  newOrderId,
                });
              } else if (newThumbnail && newThumbnail.previewSrc && originalMedia.thumbnail) {
                const originalThumbnail = originalMedia.thumbnail;
                if (originalThumbnail.cdnLink !== newThumbnail.previewSrc) {
                  commands.push({
                    ...defaultCommand,
                    command: 'UPDATE',
                    originalId: originalThumbnail.id,
                    originalUrl: originalThumbnail.cdnLink,
                    originalOrderId: originalThumbnail.orderId,
                    newId: newThumbnail.id,
                    newUrl: this.isOneOfTheCdnLink(newThumbnail.previewSrc) ? newThumbnail.previewSrc : "",
                    usageType: this.fileThumbnailUsageType,
                    newOrderId,
                  });
                }
              }
            }
          }
        }

        // console.log('commands', commands);
        // console.log("pendingUploadFiles: ", pendingUploadFiles);
        this.$emit('update', commands, pendingUploadFiles, imgBtnArr);
      },
      handleUpdate(medias) {
        // Update Image Btn display data
        const imgBtnArr = [];
        if (this.mediaType === "image") {
          // image
          medias.map((i) => ({
            id: i.id,
            imgSrc: i.previewSrc,
            imageName: i.fileName,
            usageType: i.usageType,
            isPendingUpload: !this.isOneOfTheCdnLink(i.previewSrc)
          })).forEach((i) => imgBtnArr.push(i));
        } else if (this.mediaType === "video") {
          // video
          medias.map((i) => ({
            id: i.id,
            imgSrc: i.thumbnail.previewSrc,
            imageName: i.fileName,
            usageType: i.usageType,
            isPendingUpload: !this.isOneOfTheCdnLink(i.previewSrc),
            isThumbnailPendingUpload: !this.isOneOfTheCdnLink(i.thumbnail.previewSrc)
          })).forEach((i) => imgBtnArr.push(i));
        }

        this.imgBtnArr = [...imgBtnArr];

        this.emitData(medias, imgBtnArr);
        this.closeEditModal();
      },

      // For copy from parent
      // files: File[] |
      async copyFromOtherUploader(files, isCdnLink = false) {
        await this.$refs.MediaUploadModal?.copyFromOtherUploader(files);
      },
      closeEditModal() {
        this.$refs.MediaUploadModal?.onCloseModal();
      },
      openEditModalWithMediaId(mediaId) {
        this.$refs.MediaUploadModal?.onOpenModal(mediaId);
      },
      onClickImage(mediaId) {
        if(!this.in_IsDisabled) {
          this.openEditModalWithMediaId(mediaId);
        } 
      },
    }
  }
</script>

<style scoped lang="scss">
  .gallery-container {
    display: grid;
    gap: 8px;
    width: fit-content;
    max-width: 100%;
    box-sizing: border-box;
    position: relative;
  }

  .gallery-item-container {
    position: relative;

    &:hover {
      .gallery-item-edit-pen {
        background-color: #e2e1f0;
      }
    }
  }

  .gallery-item-container {
    position: relative;
  }
  .gallery-item {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
  }
  .gallery-item-round {
    border-radius: 100%;
    overflow: visible;
    .gallery-img-wrap {
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 100%;
    }
    .gallery-item-corner {
      &.bottom-right {
        bottom: -6px;
        right: -6px;
      }
      &.top-right {
        top: -6px;
        right: -6px;
      }
    }
  }
  .gallery-item-disabled {
    cursor: not-allowed;
  }
  .gallery-item-corner {
    display: flex;
    padding: 2px 4px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.40);
    color: #fff;
    position: absolute;
    text-align: center;
    white-space: nowrap;
    leading-trim: both;
    text-edge: cap;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "inter", sans-serif;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: 0.15px;

    &.bottom-right {
      bottom: 0;
      right: 0;
    }
    &.top-right {
      top: 0;
      right: 0;
    }
  }
  .gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
  .gallery-item-add {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1/1;
    border-radius: 4px;
    border: 1px dashed #7366FF;
    background: rgba(115, 102, 255, 0.08);
    color: #7366FF;

    &:hover {
      border-color: #4433ff;
      color: #4433ff;
    }

    &.gallery-item-add-avatar {
      background: none;
    }
  }

  .gallery-item-edit-pen {
    position: absolute;
    display: inline-block;
    font-size: 16px;
    line-height: 16px;
    right: 0;
    bottom: 0;
    padding: 8px;
    border-radius: 999px;
    background-color: #f9f9f9;
    pointer-events: auto;
    cursor: pointer;
    -webkit-transition: background-color .2s ease;
    transition: background-color .2s ease;
    z-index: 1;
  }

  .cover-placeholder {
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "inter", sans-serif;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: 0.00938rem;
  }
  .gallery-item-add-error {
    border: 1px dashed #CD1515 !important;
    background: rgba(205, 21, 21, 0.04) !important;
  }
</style>